import RightPanel from '../common/RightPanel';
import useAgentsHome from './useAgentsHome';
import AgentsHomeWithDialogs from './AgentsHomeWithDialogs';
import { PanelEnvSelector } from '../pages/environments/connect-env/PanelEnvSelector';
import { useSelector } from 'react-redux';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';
import { AgentChatInstanceProvider } from './AgentChatInstanceContext';
import { ChatInstance } from './ChatInstance';

interface AgentsHomePanelProps {
  closePanel?: () => void;
}

const AgentsHomePanel = ({ closePanel }: AgentsHomePanelProps) => {
  const { isExpanded, isOpened } = useAgentsHome();
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);

  return (
    <RightPanel isOpened={isOpened} isExpanded={isExpanded}>
      <PanelEnvSelector filterByEnvsUsedInCanvas />
      <AgentChatInstanceProvider instanceId={ChatInstance.agentsPanel}>
        <AgentsHomeWithDialogs isPageView={false} closePanel={closePanel} key={crmOrgId} />
      </AgentChatInstanceProvider>
    </RightPanel>
  );
};

export default AgentsHomePanel;
